'use strict'

const metadata = {
  namespaced: true,
  state: {
    staMatrix: [],
    productConfig: null,
    blendedProductConfig: null,
    bioProductConfig: null,
    networkConfig: null,
    networks: [],
  },
  getters: {
    productConfig(state) {
      return state.productConfig;
    },
    blendedProductConfig(state) {
      return state.blendedProductConfig;
    },
    bioProductConfig(state) {
      return state.bioProductConfig;
    },
    staMatrix(state) {
      return state.staMatrix;
    },
    networkConfig(state) {
      return state.networkConfig;
    },
    networks(state) {
      return state.networks;
    },
  },
  mutations: {
    SET_PRODUCT_CONFIG: (state, payload) => {
      state.productConfig = payload;
      state.blendedProductConfig = [payload.BlendedDieselBioId, payload.BlendedGasoilId];
      state.bioProductConfig = [payload.BioDieselId, payload.BioDieselForGasoilId];
    },
    SET_STA_MATRIX: (state, payload) => {
      state.staMatrix = payload;
    },
    SET_NETWORK_CONFIG: (state, payload) => {
      state.networkConfig = payload;
    },
    SET_NETWORK_LIST: (state, payload) => {
      state.networks = payload;
    },
  },
  actions: {
    getMetadataConfig: async ({ commit, getters, rootState }) => {
      const productConfig = getters.productConfig;
      const networkConfig = getters.networkConfig;
      const userLoggedIn = rootState.login.userLoggedIn.id != null;
      if ((!productConfig || !networkConfig) && userLoggedIn) {
        const [products, networks] = await Promise.all([
          (await rootState.axios.get("/api/config/products")).data,
          (await rootState.axios.get("/api/config/networks")).data,
        ]);
        commit("SET_PRODUCT_CONFIG", products);
        commit("SET_NETWORK_CONFIG", networks);
      }
    },
    getStaMatrix: async ({ commit, rootState }) => {
      const staMatrix = (await rootState.axios.get("/api/sta-matrix")).data;
      commit("SET_STA_MATRIX", staMatrix);
    },
    getNetworks: async ({ commit, rootState }) => {
      const networks = (await rootState.axios.get("/api/networks")).data;
      commit("SET_NETWORK_LIST", networks);
    },
  },
};

export default metadata;